import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, useMemo } from "react";
import Searcher from "../searcher/index.js";
import SearcherFlightHotel from "../searcher-flight-hotel/index.js";
import SearcherSwitcher from "../searcher-switcher/index.js";
import { FormRadioButtonGroup } from "../../../forms/inputs/radio-button-group/index.js";
import Form from "../../../forms/others/form/index.js";
import ScrollHorizontal from "../../../structures/others/scroll-horizontal/index.js";
import { nullFunction } from "../../../../helpers/null.js";
import useIsMobile from "../../../../hooks/device/useIsMobile.js";
import { SearcherNameToId } from "./constants.js";
import useSearcherMultiPakDefaultValues from "./hooks/useSearcherMultiPakDefaultValues.js";
import useSearcherMultiPakView from "./hooks/useSearcherMultiPakView.js";
import * as S from "./styled.js";
import { parseSearcherMultiPakProps } from "./utils/index.js";
const SearcherTrainHotel = /*#__PURE__*/ lazy(()=>import("../searcher-train-hotel/index.js"));
const SearcherFerryHotel = /*#__PURE__*/ lazy(()=>import("../searcher-ferry-hotel/index.js"));
const SearcherTou = /*#__PURE__*/ lazy(()=>import("../searcher-tou/index.js"));
const searchers = {
    FLI_HOT: SearcherFlightHotel,
    TRA_HOT: SearcherTrainHotel,
    FER_HOT: SearcherFerryHotel,
    TOU: SearcherTou
};
const SearcherMultiPakView = (props)=>{
    const { inputs , productValue , visibleSearchers  } = useSearcherMultiPakView(props);
    const showSearcherOptions = useMemo(()=>inputs.product.options.length > 1, [
        inputs.product.options.length
    ]);
    const productInput = useMemo(()=>/*#__PURE__*/ _jsx(FormRadioButtonGroup, {
            ...inputs.product
        }), [
        inputs.product
    ]);
    return /*#__PURE__*/ _jsx(Searcher, {
        "data-testid": "SearcherMultiPak",
        top: showSearcherOptions && /*#__PURE__*/ _jsx(ScrollHorizontal, {
            children: productInput
        }),
        children: Object.entries(visibleSearchers).map(([key, visibleSearcher])=>visibleSearcher && /*#__PURE__*/ _jsx(S.VisibleSearcherWrapper, {
                $isActive: key === productValue || SearcherNameToId[key] === productValue,
                children: /*#__PURE__*/ _jsx(SearcherSwitcher, {
                    searchers: searchers,
                    id: SearcherNameToId[key],
                    searcher: visibleSearcher.searcher?.props ?? visibleSearcher.searcher?.data ?? undefined,
                    endpoint: visibleSearcher.endpoint
                }, SearcherNameToId[key])
            }, key))
    });
};
const SearcherMultiPak = (props)=>{
    const isMobile = useIsMobile();
    const finalProps = parseSearcherMultiPakProps(isMobile, props);
    const defaultValues = useSearcherMultiPakDefaultValues(finalProps);
    if (!finalProps) return null;
    return /*#__PURE__*/ _jsx(Form, {
        formTag: "div",
        onSubmit: nullFunction,
        defaultValues: defaultValues,
        children: /*#__PURE__*/ _jsx(SearcherMultiPakView, {
            ...finalProps
        })
    });
};
export default SearcherMultiPak;

//# sourceMappingURL=index.js.map